import React from 'react';

const SkeletonLoader = () => (
  <div className="aptv2-skeleton-wrapper" aria-hidden="true">
    <span className="sr-only">Loading appointment types…</span>
    <div className="aptv2-skeleton-header" />
    {[1, 2, 3, 4].map((i) => (
      <div key={i} className="aptv2-skeleton-card">
        <div className="aptv2-skeleton-icon" />
        <div className="aptv2-skeleton-body">
          <div className="aptv2-skeleton-line aptv2-skeleton-line--title" />
          <div className="aptv2-skeleton-line aptv2-skeleton-line--desc" />
        </div>
        <div className="aptv2-skeleton-chevron" />
      </div>
    ))}
  </div>
);

export default SkeletonLoader;
